module.exports = __webpack_public_path__ + "static/my-profile.b6481875.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/images/my-profile.jpg
// module id = 1154
// module chunks = 263791100135453